<h1 mat-dialog-title>{{ 'bookmarkManagerDialog.title' | translate }}</h1>
<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  <div class="description">{{ 'bookmarkManagerDialog.labels.bookmarkInfo' | translate }}</div>
  <mat-table [dataSource]="tableDataSrc" cdkDropList [cdkDropListData]="bookmarks" (cdkDropListDropped)="drop($event)" class="data-table">
    <ng-container matColumnDef="position">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let bookmark" class="drag-cell">
        <button mat-icon-button>
          <mat-icon
            cdkDragHandle
            (touchstart)="dragDisabled = false"
            (touchend)="dragDisabled = true"
            (mousedown)="dragDisabled = false"
            (mouseup)="dragDisabled = true">
            drag_indicator
          </mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="label">
      <mat-header-cell *matHeaderCellDef>{{ 'bookmarkManagerDialog.labels.bookmarkName' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let bookmark">
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            [(ngModel)]="bookmark.label"
            #bookmarkLabel="ngModel"
            maxlength="{{ labelMaxLength }}"
            minlength="{{ labelMinLength }}"
            [placeholder]="'bookmarkManagerDialog.labels.bookmarkNamePlaceholder' | translate"
            required>
          <mat-error *ngIf="bookmarkLabel.errors?.required">{{ 'common.errors.fieldRequired' | translate }}</mat-error>
          <mat-error *ngIf="bookmarkLabel.errors?.maxlength">{{ 'common.errors.labelLong' | translate }}</mat-error>
          <mat-error *ngIf="bookmarkLabel.errors?.minlength">{{ 'bookmarkManagerDialog.errors.nameMinLength' | translate }}</mat-error>
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="url">
      <mat-header-cell *matHeaderCellDef>{{ 'bookmarkManagerDialog.labels.bookmarkUrl' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let bookmark">
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text" 
            [(ngModel)]="bookmark.url"
            #bookmarkURL="ngModel"
            minlength="{{ urlMinLength }}"
            [placeholder]="'bookmarkManagerDialog.labels.bookmarkUrlPlaceholder' | translate"
            required>
          <mat-error *ngIf="bookmarkURL.errors?.required">{{ 'common.errors.fieldRequired' | translate }}</mat-error>
          <mat-error *ngIf="bookmarkURL.errors?.minlength">{{ 'bookmarkManagerDialog.errors.urlMinLength' | translate }}</mat-error>
        </mat-form-field>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let bookmark; let i = index">
        <button mat-icon-button (click)="removeBookmark(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="tableCols"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: tableCols;"
      class="list-action-hover"
      cdkDrag
      [cdkDragData]="row"
      [cdkDragDisabled]="dragDisabled"
      (cdkDragReleased)="dragDisabled = true"
      [attr.test-id]="'row-' + row.name">
    </mat-row>
  </mat-table>
  <span class="add-bookmark-button">
    <a (click)="addBookmark()">
      <mat-icon matPrefix>add</mat-icon>
      {{ ( bookmarks.length ? 'bookmarkManagerDialog.labels.addAnotherBookmark' : 'bookmarkManagerDialog.labels.addABookmark') | translate }}
    </a>
  </span>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button test-id="cancel-button" mat-dialog-close mat-stroked-button>{{ 'common.actions.cancel' | translate }}</button>
  <button test-id="create-button" (click)="saveBookmarks()" [disabled]="!canSave()" mat-flat-button color="primary">
    {{ 'common.actions.saveChanges' | translate }}
  </button>
</mat-dialog-actions>
